import React, { useState } from 'react'
import Module from '../../../layout/Module'
import { 
  useNavigate,
  Routes,
  Route
} from 'react-router-dom'
import NotFoundPage from '../../../NotFoundPage/NotFoundPage';
import UsersList from './List/List';
import AlertSaveButton from '../../../button/AlertSaveButton';
import { useDispatch, useSelector } from 'react-redux';
import UserPreview from './Preview/Preview';
import EditUser from './Edit/Edit';
import DialogRoles from './DialogRoles/DialogRoles';
import { updateForm } from '../../../../store/actions/user.actions';
import CreateUser from './Create/Create';
import useFlags from '../../../../hooks/setting/useFlags';

const Users = () => {
  const [show, setShow] = useState(false)
  const permissions = useSelector((state) => state?.session?.permissions?.user || {})
  const preview = useSelector((state) => state?.user?.preview || null)
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {  } = useFlags()

  const onSave = (form) => {
    dispatch(updateForm(form))
    navigate(`/dashboard/users/create`)
  }

  return (
    <Module moduleName='users'>
      <Module.Header
        title='Users'
        titleLink={'/dashboard/users'}
      >
        <div className='flex justify-end items-center gap-2'>
          { permissions?.created && (
            <AlertSaveButton
              submodule='Users'
              icon='plus'
              title='Create'
              color='secondary'
              onDontSave={() => setShow(true)}
            />
          )}
        </div>
      </Module.Header>
      <Module.Body>
        <Routes>
          <Route index element={<UsersList />} />
          <Route 
            path='create'
            element={<CreateUser />}
          />
          <Route 
            path='edit/:id'
            element={<EditUser />}
          />
          <Route
            path='*'
            element={
              <Module.BodyFullContainer className='flex justify-center items-center'>
                <NotFoundPage />
              </Module.BodyFullContainer>
            } 
          />
        </Routes>
      </Module.Body>
      { preview && <UserPreview /> }
      { show && <DialogRoles show={show} onClose={() => setShow(false)} onSave={onSave} rolesId={[]} /> }
    </Module>
  )
}

export default Users;
